import { render, staticRenderFns } from "./workplanComponent.vue?vue&type=template&id=63939445&scoped=true"
import script from "./workplanComponent.vue?vue&type=script&lang=js"
export * from "./workplanComponent.vue?vue&type=script&lang=js"
import style0 from "./workplanComponent.vue?vue&type=style&index=0&id=63939445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63939445",
  null
  
)

export default component.exports